<template>
  <div class="loan-detail-container">
    <HeaderCard />
    <SubjectInfoCard :subjectInfo="subjectInfo" />
    <BusinessInfoCard :businessInfo="businessInfo" />
    <LoanInfoCard v-if="isShowLoanInfoCard" :loanInfo="loanInfo" />
    <FooterCard :subjectInfo="subjectInfo" />
  </div>
</template>

<script>
import HeaderCard from './HeaderCard.vue'
import SubjectInfoCard from './SubjectInfoCard.vue'
import BusinessInfoCard from './BusinessInfoCard.vue'
import LoanInfoCard from './LoanInfoCard.vue'
import FooterCard from './FooterCard.vue'
import {
  getBankDetailViewBaseInfo,
  getBankDetailViewBusinessInfo
} from '@/api/RuralFinance'

export default {
  name: 'BankLoanDetailView',
  components: {
    HeaderCard,
    SubjectInfoCard,
    BusinessInfoCard,
    LoanInfoCard,
    FooterCard
  },
  data() {
    return {
      subjectInfo: {
        // name: '四川喆立农业专业合作社',
        // creditCode: '93511703MADCF1EB57',
        // legalPerson: '杨腾明',
        // contactPerson: '李艳',
        // contactPhone: '18282232953',
        // location: '四川省达州市达川区南岳镇九元村',
        // businessLicenseUrl:
        //   '/admin/file/cqjy/register/202506/aa5135acad2148d295547ea58fafd234.jpeg',
        // idCardFrontUrl: '/admin/file/cqjy/sfz/202506/d875ff4253d44cbaaec050d17a2a9094.jpg',
        // idCardBackUrl: '/admin/file/cqjy/sfz/202506/615678b6279b4f0bbce84cb03eff239a.jpg'
      },

      businessInfo: {},

      loanInfo: {
        // productName: '裕农快贷',
        // amount: '500万元',
        // term: '12 个月',
        // operatingYears: '3年',
        // annualTurnover: '300万元',
        // purpose: '支付种植成本',
        // businessDescription:
        //   '本公司成立于2024年，主要从事水稻等粮油作物的种植与销售。目前拥有流转土地1400亩，年产量约900吨。计划扩大种植规模至2000亩，需支付种子化肥采购等种植成本，预计年收入可增长40%以上。',
        // attachments: [
        //   {
        //     name: 'XXXX收入证明.pdf',
        //     url: '/admin/file/cqjy/financeAdd/3d25e09ac9d84ed986d06a75c3b727a3.pdf'
        //   },
        //   { name: 'XXXX收据.pdf', url: '#' }
        // ]
      }
    }
  },
  computed: {
    isShowLoanInfoCard() {
      return this.$route.query?.from == 'bankLoanDetailViewTable'
    }
  },
  async created() {
    await this.init()
  },
  methods: {
    async init() {
      let applyId = this.$route.query.applyId
      if (applyId) {
        await this.loadBaseInfo(applyId)
        await this.loadBusinessInfo(applyId)
      } else {
        this.detailInfo = JSON.parse(this.$route.query.detailInfo || '{}')
        this.subjectInfo = this.mapDataToSubjectInfo(this.detailInfo) || {}
        this.businessInfo = this.detailInfo.applyBusinessDataVo || {}
      }
    },

    async loadBaseInfo(applyId) {
      let params = { applyId }
      let res = await getBankDetailViewBaseInfo(params)
      if (res.code == 0) {
        this.subjectInfo = this.mapDataToSubjectInfo(res.data)
        this.loanInfo = this.mapDataToLoanInfo(res.data)
      }
    },

    async loadBusinessInfo(applyId) {
      let params = { applyId }
      let res = await getBankDetailViewBusinessInfo(params)
      if (res.code == 0) {
        this.businessInfo = res.data
      }
    },

    mapDataToSubjectInfo(data) {
      return {
        name: data.name || '',
        creditCode: data.idCardNo || '',
        legalPerson: data.legalPersonName || '',
        contactPerson: data.contactName || '',
        contactPhone: data.contactPhone || '',
        location: data.address || '',
        businessLicenseUrl: data.businessLicense || '',
        idCardFrontUrl: data.bossCardFront || '',
        idCardBackUrl: data.bossCardBack || '',
        identityId: data.identityId || '',
        identityType: data.identityType || ''
      }
    },

    mapDataToLoanInfo(data) {
      return {
        productName: data.productName || '',
        amount: data.money ? `${data.money}元` : '',
        term: data.loanTerm ? `${data.loanTerm}个月` : '',
        operatingYears: data.operatYear ? `${data.operatYear}年` : '',
        annualTurnover: data.income ? `${data.income}元` : '',
        purpose: data.fundUsage || '',
        businessDescription: data.use || '',
        attachments: data.files
          ? JSON.parse(data.files).map(item => ({
              name: item.FilesName || '',
              url: item.imgUrl || ''
            }))
          : []
      }
    }
  }
}
</script>

<style lang="less" scoped>
// 变量定义 - 从设计稿提取
@primary-color: #2563eb; // 主色调
@primary-blue: #1677ff; // 按钮主色
@success-color: #16a34a; // 成功色（金额）
@text-primary: #1f2937; // 主文本色
@text-secondary: #6b7280; // 次要文本色
@text-active: #2563eb; // 激活状态文本色
@gray-light: #d1d5db; // 浅灰色
@white: #ffffff; // 白色背景
@border-radius: 6px; // 圆角
@box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05); // 阴影
@button-shadow: 0px 2px 0px 0px rgba(5, 145, 255, 0.1); // 按钮阴影

// 确保页面内容不会超出视口
* {
  box-sizing: border-box;
}

.loan-detail-container {
  background-color: #f8f9fa;
  width: 100%;
  max-width: 1248px;
  min-height: 1060px;
  margin: 0 auto;
  padding: 0 24px 24px 24px;
  // 确保容器本身不会超出视口
  overflow-x: hidden;

  // 为所有子组件添加间距
  > * {
    margin-bottom: 24px;
    // 确保每个组件都能在容器内正确显示
    max-width: 100%;
    box-sizing: border-box;
  }

  // 移除最后一个组件的底部间距
  > *:last-child {
    margin-bottom: 0;
  }

  // 为表格组件添加特殊处理
  :deep(.planting-loan-card) {
    width: 100%;
    overflow-x: visible;

    .table-container {
      width: 100%;
      overflow-x: auto;
      max-width: 100%;
      margin: 0 -4px;
      padding: 0 4px;
    }
  }
}

// 全局组件溢出控制
:deep(.el-table) {
  width: 100%;
  max-width: 100% !important;
}

// 响应式设计
@media (max-width: 1200px) {
  .loan-detail-container {
    padding: 16px;
    max-width: 100%;
  }

  // 调整所有表格列宽
  :deep(.el-table-column) {
    width: auto !important;
    max-width: 200px !important;
  }
}

@media (max-width: 1024px) {
  .loan-detail-container {
    padding: 16px;

    > * {
      margin-bottom: 16px;
    }
  }
}

@media (max-width: 768px) {
  .loan-detail-container {
    padding: 12px;

    > * {
      margin-bottom: 12px;
    }
  }

  // 移动端优化
  :deep(.el-table) {
    font-size: 12px;

    .el-table__header-wrapper,
    .el-table__body-wrapper {
      font-size: 12px;
    }

    .el-table__header {
      th {
        padding: 8px 4px;
      }
    }

    .el-table__body {
      td {
        padding: 8px 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
